import {first, last, slice} from 'lodash'
import Swal from 'sweetalert2'
import {trans} from './setup/locales'

export const Toast = Swal.mixin({
  toast: true,
  position: 'top-end',
  showConfirmButton: false,
  timer: 3000,
  input: null,
  timerProgressBar: true,
  onOpen: (toast) => {
    toast.addEventListener('mouseenter', Swal.stopTimer)
    toast.addEventListener('mouseleave', Swal.resumeTimer)
  },
  onBeforeOpen(toast) {
    const select = toast.querySelector('select')
    if (select !== null) {
      select.classList.add('browser-default')
    }
  }
})

const alert = document.querySelector('.flash-alert')
if (alert !== null) {
  const type = alert.dataset.alertType
  const title = alert.dataset.alertTitle
  const duration = alert.dataset.alertDuration

  Toast.fire({
    icon: type,
    title: title,
    timer: duration
  })
}

const displayLoader = value => {
  document.querySelector('body').classList[value ? 'remove' : 'add']('loaded')
}

export const showLoading = value => {
  displayLoader(value)
  document.querySelector('#loader').style.display = 'block'
  document.querySelector('#progressbar').style.display = 'none'
}

export const showAlert = async (message) => {
  await Swal.fire({
    title: trans('terms.error'),
    text: message,
    icon: 'error',
    showCancelButton: false,
    confirmButtonText: trans('terms.ok'),
    allowOutsideClick: false,
    allowEscapeKey: false,
    confirmButtonColor: 'var(--success-color)',
    cancelButtonColor: 'var(--danger-color)',
  })
}

export const showConfirm = async (message) => {
  return await Swal.fire({
    title: '',
    text: message,
    icon: 'warning',
    showCancelButton: true,
    confirmButtonText: trans('terms.yes'),
    cancelButtonText: trans('terms.no'),
    allowOutsideClick: false,
    allowEscapeKey: false,
    confirmButtonColor: 'var(--success-color)',
    cancelButtonColor: 'var(--danger-color)',
  })
}

export const showProgress = (value, percent) => {
  displayLoader(value)
  document.querySelector('#loader').style.display = 'none'
  document.querySelector('#progressbar').style.display = 'block'
  document.querySelector('#progressbar').querySelector('.determinate').style.width = `${percent}%`
}

export const oxford = (list = [], separator = ', ', lastSeparator = 'and') => {
  switch (list.length) {
    case 0:
      return ''
    case 1:
      return first(list)
    case 2:
      return `${first(list)} ${lastSeparator} ${last(list)}`
    default:
      return `${slice(list, 0, -1).join(separator)} ${lastSeparator} ${last(list)}`
  }
}
